export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7780.cb4b2a5d.jpg";